import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { useDropdown } from "@/hooks";
import styles from "@/styles/DropdownMenu.module.scss";
import classnames from "classnames";
import { useCallback, useEffect, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconArrow = function IconArrow(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      transform: "translate(0.813 0.813)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M.6.6l6,6.5,6-6.5",
        fill: "none",
        stroke: "#e6e6e6",
        strokeLinecap: "round",
        strokeWidth: "2"
      })
    })
  }));
};
IconArrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.826",
  height: "9.387",
  viewBox: "0 0 14.826 9.387"
};
export default function DropdownSelect(_ref) {
  let {
    options,
    right = false,
    mouseOver = false,
    defaultValue,
    onSelect,
    disabled = false,
    className
  } = _ref;
  const {
    buttonRef,
    contentRef,
    show,
    setShow,
    listeners
  } = useDropdown({
    mouseOver
  });
  const {
    0: selected,
    1: setSelected
  } = useState();
  const handleMouseOver = useCallback(() => {
    if (!disabled) {
      listeners.handleMouseOver();
    }
  }, [listeners, disabled]);
  const handleMouseLeave = useCallback(() => {
    if (!disabled) {
      listeners.handleMouseLeave();
    }
  }, [listeners, disabled]);
  const handleClick = useCallback(() => {
    if (!disabled) {
      listeners.handleClick();
    }
  }, [listeners, disabled]);
  const handleSelect = useCallback(value => {
    return () => {
      if (!disabled) {
        const selectOption = options.find(option => option.value == value);
        setSelected(selectOption);
        setShow(false);
        if (onSelect) {
          onSelect(selectOption);
        }
      }
    };
  }, [disabled]);
  useEffect(() => {
    if (!defaultValue) {
      setSelected(options[0]);
    }
  }, [defaultValue]);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.dropdown, className, {
      [styles.sort]: className == "sort"
    }),
    onMouseOver: handleMouseOver,
    onMouseLeave: handleMouseLeave,
    children: [/*#__PURE__*/_jsx("div", {
      ref: buttonRef,
      className: classnames(styles.selected, {
        [styles.show]: show
      }),
      onClick: handleClick,
      children: selected && /*#__PURE__*/_jsxs("span", {
        children: [selected.text, /*#__PURE__*/_jsx("span", {
          className: styles.caret,
          children: /*#__PURE__*/_jsx(IconArrow, {})
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      ref: contentRef,
      className: classnames(styles.content, {
        [styles.show]: show,
        [styles.right]: right
      }),
      children: !disabled && options.map(option => /*#__PURE__*/_jsx("div", {
        className: styles.option,
        onClick: handleSelect(option.value),
        children: option.text
      }, `dropdownselect-${option.value}`))
    })]
  });
}